import CodeEditor from "@uiw/react-textarea-code-editor";
import { useTheme } from "../services/ThemeProvider";

// The editor switches its own palette on data-color-mode. Callers set a light
// border inline, so in dark that one value is swapped; light is untouched.
export default function ThemedCodeEditor({ style, ...props }) {
  const { resolvedTheme } = useTheme();
  const themedStyle =
    resolvedTheme === "dark" && style?.border ? { ...style, border: "1px solid #1f2937" } : style;
  return <CodeEditor data-color-mode={resolvedTheme} {...props} style={themedStyle} />;
}
